import { MutationObserver } from "@tanstack/react-query";

import type { IFiltersSelectionDto } from "../../types/dto";
import { createFiltersSelectionMutationOptions } from "../mutations/options";
import { createFilterSelectionQuery } from "../queries/options";
import type { SelectedFiltersContext } from "../types";

import type { IAdvancedSearchFilteringQueryClient, IAdvancedSearchFilteringQueryClientDeps } from "./types";

export const createAdvancedSearchFilteringQueryClient = ({
    queryClient,
}: IAdvancedSearchFilteringQueryClientDeps): IAdvancedSearchFilteringQueryClient => {
    const ensureFiltersSelectionQueryData = () => {
        return queryClient.ensureQueryData<IFiltersSelectionDto>(createFilterSelectionQuery());
    };

    const pinFilter = async (filterKey: string): Promise<void> => {
        const current = await ensureFiltersSelectionQueryData();

        if (current.filters.includes(filterKey)) {
            return;
        }

        const observer = new MutationObserver<void, Error, readonly string[], SelectedFiltersContext>(
            queryClient,
            createFiltersSelectionMutationOptions(queryClient),
        );

        // The shared options' onError already rolls back the optimistic write and reports to
        // Sentry, so swallow here to keep this safe for the imperative fire-and-forget caller
        // otherwise the rejection escapes
        await observer.mutate([...current.filters, filterKey]).catch(() => undefined);
    };

    return {
        pinFilter,
    };
};
